import { useEffect, useState } from "react";
import { collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "../firebaseConfig";

function readYearFromSnapshot(snap, field) {
  const d = snap?.docs?.[0];
  if (!d) return null;
  const y = Number(d.data()?.[field]);
  return Number.isFinite(y) ? y : null;
}

export function useAllTimeYearRange(enabled) {
  const [range, setRange] = useState(null); // { startYear, endYear }
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;
    const fetchRange = async () => {
      setLoading(true);
      setErr("");
      try {
        const [txnAsc, evAsc] = await Promise.all([
          getDocs(
            query(collection(db, "transactions"), orderBy("Year", "asc"), limit(1))
          ),
          getDocs(
            query(collection(db, "privateEvents"), orderBy("year", "asc"), limit(1))
          ),
        ]);

        const years = [
          readYearFromSnapshot(txnAsc, "Year"),
          readYearFromSnapshot(evAsc, "year"),
        ].filter((y) => Number.isFinite(y));

        const now = new Date();
        const fallback = now.getFullYear();
        const endYear = fallback;
        const startYearRaw = years.length ? Math.min(...years) : fallback;
        const startYear = Math.min(startYearRaw, endYear);

        if (!cancelled) setRange({ startYear, endYear });
      } catch (e) {
        console.error("Error fetching all-time year range:", e);
        if (!cancelled) setErr("Failed to load all-time range. Please try again.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchRange();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { range, loading, err };
}
